import { createReducer } from 'store/helpers';
import {
  REQUEST_STARTED,
  REQUEST_COMPLETED,
  SET_USER,
} from 'store/actions/user';
import { getUser } from 'services/token';
const initialState = {
  user: JSON.parse(getUser()),
  isLoading: false,
  error: '',
};

const requestStarted = state => state.merge({ isLoading: true });
const setUser = (state, { user }) => state.merge({ user });
const requestCompleted = state => state.merge({ isLoading: false });

const handlers = {
  [REQUEST_STARTED]: requestStarted,
  [REQUEST_COMPLETED]: requestCompleted,
  [SET_USER]: setUser,
};

export default createReducer(initialState, handlers);
